var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 100,
    height: 100,
    rx: 50,
    stroke: "#FBF8FF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 70V66C68 63.8783 67.1571 61.8434 65.6568 60.3431C64.1566 58.8429 62.1217 58 60 58H44C41.8783 58 39.8434 58.8429 38.3431 60.3431C36.8429 61.8434 36 63.8783 36 66V70M60 42C60 46.4183 56.4183 50 52 50C47.5817 50 44 46.4183 44 42C44 37.5817 47.5817 34 52 34C56.4183 34 60 37.5817 60 42Z",
    stroke: "#223CDD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default_avatar.dd984fba78f7707213831571425e8176.svg";
export { ForwardRef as ReactComponent };